// Forward-only status flow per fulfilment type (mirrors qerchabackend/utils/orderFlow.js).
// The last step is final.
export const FLOWS = {
  delivery: ['pending', 'paid', 'processing', 'packed', 'shipped', 'out_for_delivery', 'delivered'],
  pickup: ['pending', 'paid', 'processing', 'packed', 'ready_for_pickup', 'picked_up'],
};

export const STEP_LABELS = {
  processing: 'Processing',
  packed: 'Packed',
  shipped: 'Shipped',
  out_for_delivery: 'Out for delivery',
  delivered: 'Delivered',
  ready_for_pickup: 'Ready for pickup',
  picked_up: 'Picked up',
};

// Steps the supplier may still move the order to
export function nextSteps(fulfillmentType, currentStatus) {
  const flow = FLOWS[fulfillmentType] || [];
  const currentIndex = flow.indexOf(currentStatus);
  if (currentIndex === -1) return [];
  return flow.slice(currentIndex + 1);
}

export function isFinished(fulfillmentType, status) {
  const flow = FLOWS[fulfillmentType] || [];
  return flow.length > 0 && flow[flow.length - 1] === status;
}
